import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { SidebarComponent } from "./features/nav/sidebar/sidebar.component";
import { NavigationEnd, Router, RouterOutlet } from "@angular/router";
import { AlertComponent } from "./shared/alert/alert.component";
import { filter, Observable } from 'rxjs';
import { CommonModule } from '@angular/common';
import { MaintenanceData, MaintenanceWindowService } from './core/services/api/maintenanceWindow.service';
import { MaintenancePageComponent } from "./features/maintenance-hub/maintenance-page/maintenance-page.component";
import { PwaUpdateService } from './core/services/pwa-update.service';
import { FooterComponent } from './shared/footer/footer.component';

// Auth-only routes where the sidebar must not appear
const AUTH_ROUTES = ['/login', '/signup', '/register', '/forgot-password'];

@Component({
  selector: 'app-root',
  imports: [SidebarComponent, RouterOutlet, AlertComponent, CommonModule,MaintenancePageComponent,FooterComponent ],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App implements OnInit{

  isLandingPage = false;
  isAuthPage = false;
  isMobileSidebarOpen = false;
  maintenanceData$!: Observable<MaintenanceData | null>;

  isHamHidden = false;
 
  private lastScrollY = 0;
  private readonly hideThreshold = 80;   // px scrolled down before it's allowed to hide
  private readonly revealDelta = 4;      // px of upward scroll needed to instantly reveal it
  private ticking = false;

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    if (this.ticking) return;
    this.ticking = true;
 
    requestAnimationFrame(() => {
      this.handleScroll(this.getScrollTop());
      this.ticking = false;
    });
  }
 
  private getScrollTop(): number {
    return (
      window.scrollY ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0
    );
  }
 
  private handleScroll(currentY: number): void {
    const delta = currentY - this.lastScrollY;
 
    // Always keep it visible near the top of the page, regardless of direction
    if (currentY < this.hideThreshold) {
      this.isHamHidden = false;
    }
    // Scrolling down past the threshold -> hide
    else if (delta > 0) {
      this.isHamHidden = true;
    }
    // Any scroll-up movement -> reveal immediately
    else if (delta < -this.revealDelta) {
      this.isHamHidden = false;
    }
 
    // Never hide while the mobile sidebar is open — user needs the button to close it
    if (this.isMobileSidebarOpen) {
      this.isHamHidden = false;
    }
 
    this.lastScrollY = currentY;
  } 

  constructor(
    private router: Router,
    private maintenanceService: MaintenanceWindowService,
    private pwaUpdateService: PwaUpdateService
  ) {
    // ─── Route detection ─────────────────────────────
    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe((e: any) => {
        this.isLandingPage =
          e.url === '/' ||
          e.url.startsWith('/pick-me-right') ||
          e.url.startsWith('/policies');
          this.isAuthPage = AUTH_ROUTES.some(r => e.url.startsWith(r));

          // Close mobile sidebar on every navigation
          this.isMobileSidebarOpen = false;
      });

    this.maintenanceData$ = this.maintenanceService.maintenance$;
    this.pwaUpdateService.init();
  }

  ngOnInit(): void {
    // ...existing ngOnInit logic
    this.lastScrollY = this.getScrollTop();
  }

  toggleSidebar(): void {
    this.isMobileSidebarOpen = !this.isMobileSidebarOpen;
  }

  // Desktop: always visible. Mobile: driven by toggle.
  get isSidebarVisible(): boolean {
    return window.innerWidth >= 992 || this.isMobileSidebarOpen;
  }
  
  closeSidebar(): void {
    this.isMobileSidebarOpen = false;
  }

}